import React from 'react';

export const name = 'flag-HR';

export const FlagHR = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_199)">
      <mask
        id="mask0_2_199"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_199)">
        <path
          d="M24 12C24 10.5328 23.7375 9.12657 23.25 7.82813L12 7.30313L0.749992 7.82813C-0.25014 10.5195 -0.25014 13.4806 0.749992 16.1719L12 16.6969L23.25 16.1719C23.7375 14.8734 24 13.4672 24 12Z"
          fill="#EEEEEE"
        />
        <path
          d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24Z"
          fill="#0052B4"
        />
        <path
          d="M0.75 7.82812H23.25C22.3976 5.53158 20.8627 3.55095 18.8516 2.15229C16.8406 0.753628 14.4496 0.00393677 12 0.00393677C9.55036 0.00393677 7.15941 0.753628 5.14838 2.15229C3.13728 3.55095 1.60243 5.53158 0.75 7.82812Z"
          fill="#D80027"
        />
        <path
          d="M15.1312 8.34374H13.0453L13.3922 5.73749L14.7844 4.69687L16.1719 5.73749V7.82812L15.1312 8.34374ZM8.86875 8.34374H10.9547L10.6078 5.73749L9.21563 4.69687L7.82812 5.73749V7.82812L8.86875 8.34374Z"
          fill="#338AF3"
        />
        <path
          d="M13.3922 8.34374H10.6078V5.73749L12 4.69687L13.3922 5.73749V8.34374Z"
          fill="#0052B4"
        />
        <path
          d="M7.82812 7.82812V13.5656C7.8285 14.2149 7.98037 14.8551 8.2717 15.4353C8.56303 16.0155 8.98575 16.5197 9.50625 16.9078L10.2328 16.725L11.1562 17.6531C11.4339 17.7098 11.7166 17.7381 12 17.7375C12.2818 17.7378 12.5629 17.7095 12.8391 17.6531L13.8891 16.7766L14.4984 16.9078C15.018 16.5192 15.4399 16.0148 15.7304 15.4346C16.0209 14.8544 16.1721 14.2145 16.1719 13.5656V7.82812H7.82812Z"
          fill="#EEEEEE"
        />
        <path
          d="M7.82812 7.82812H9.49688V9.49688H7.82812V7.82812ZM11.1656 7.82812H12.8344V9.49688H11.1656V7.82812ZM14.5031 7.82812H16.1719V9.49688H14.5031V7.82812ZM9.49688 9.49688H11.1656V11.1656H9.49688V9.49688ZM12.8344 9.49688H14.5031V11.1656H12.8344V9.49688ZM7.82812 11.1656H9.49688V12.8344H7.82812V11.1656ZM9.49688 12.8344H11.1656V14.5031H9.49688V12.8344ZM11.1656 11.1656H12.8344V12.8344H11.1656V11.1656ZM14.5031 11.1656H16.1719V12.8344H14.5031V11.1656ZM12.8344 12.8344H14.5031V14.5031H12.8344V12.8344ZM11.1656 14.5031H12.8344V16.1719H11.1656V14.5031ZM9.49688 14.5031H7.93594C8.07656 15.1266 8.35781 15.6938 8.74688 16.1719H9.49688V14.5031ZM14.5031 16.1719H15.2531C15.6456 15.6837 15.9227 15.1133 16.0641 14.5031H14.5031V16.1719ZM9.49688 16.1719V16.9031C9.99056 17.2739 10.5606 17.5301 11.1656 17.6531V16.1719H9.49688ZM12.8344 16.1719V17.6531C13.4394 17.5301 14.0094 17.2739 14.5031 16.9031V16.1719H12.8344Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_199">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
